<p>
  <strong>Pro Tip:</strong> Looks like this is a re-occurring error. Let’s look
  at its scope and effect for your application.
</p>
<a
  uiSref="groups-show"
  [uiParams]="{ groupId: group.id, tab: 'aggregations' }"
  [uiOptions]="{ reload: true }"
  class="btn btn--success btn--default"
  (click)="dismissCallout()"
>
  Visit Aggregations page
</a>
